import ImagePerson from "@/components/functionals/ImagePerson";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import StatusTasks from "@/components/cmi/ObjectivesReport/StatusTasks";
import DelayedTasks from "@/components/cmi/ObjectivesReport/DelayedTasks";
import TasksFixedStatusColor from "@/components/functionals/TasksFixedStatusColor";

export const TaskColumns = [
  {
    prop: "ObjetivesGanttID",
    label: "Objetivo",
    "min-width": 100,
    sortable: true,
    align: "center",
    fixed: true
    //formatter: BlinkingObjective
  },
  {
    prop: "CombinedTaskId",
    label: "Numero",
    "min-width": 100,
    sortable: true,
    align: "center",
    fixed: true
    //formatter: BlinkingObjective
  },
  {
    prop: "ShortDescription",
    label: "Descripción",
    "min-width": 500,
    sortable: true,
    fixed: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "IsFixed",
    label: "Fijada?",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: TasksFixedStatusColor
  },
  {
    prop: "EstimatedTime",
    label: "Tiempo",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: (row) => row.EstimatedTime + " h"
  },
  {
    prop: "ResponsibleName",
    label: "Responsable",
    "min-width": 200,
    sortable: true,

    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsiblePhoto"
    }
  },
  {
    prop: "Time",
    label: "Retraso",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: DelayedTasks
  },
  {
    prop: "Status",
    label: "Estado",
    "min-width": 200,
    sortable: true,
    align: "center",
    formatter: StatusTasks
  },
  {
    prop: "PercentageProsposal",
    label: "Avance",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: (row) => row.PercentageProsposal + " %"
  },
  {
    prop: "InitialDate",
    label: "Fecha de Inicio",
    "min-width": 150,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
  },
  {
    prop: "LimiteDate",
    label: "Fecha de Fin",
    "min-width": 150,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
  }
];

export const TaskActions = (/*thiss*/) => [
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "edit_task"
    //condition: (row) => row.ResponsableId !== thiss.currentUser.EmployeeId
  },
  {
    icon: "el-icon-close",
    label: "Cerrar",
    command: "close_task"
    //condition: (row) => row.ResponsableId !== thiss.currentUser.EmployeeId
  },
  {
    icon: "el-icon-delete",
    label: "Eliminar",
    command: "delete_task"
    //condition: (row) => row.ResponsableId !== thiss.currentUser.EmployeeId
  }
];
